export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    viewerNoCss: 'specs.events.ui.viewerNoCss',
    DashboardRedesign: 'specs.events.ui.DashboardRedesign',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    NewSeatingTemplates: 'specs.events.ui.NewSeatingTemplates',
    NewDashboardReleaseModal: 'specs.events.ui.NewDashboardReleaseModal',
    NewMobileWidgetLayouts: 'specs.events.ui.NewMobileWidgetLayouts',
    NewMobileWidgetSettings: 'specs.events.ui.NewMobileWidgetSettings',
    PublishedListTips: 'specs.events.PublishedListTips',
    EventsHeadless: 'specs.events.ui.EventsHeadless',
    EventDetailsMobileUpdate: 'specs.events.ui.DetailsPageMobileUpdate',
    DetailsPageMobileSettings: 'specs.events.ui.DetailsPageMobileSettings',
};
//# sourceMappingURL=experiments.js.map